import type { FC } from "react";
import React from "react";

interface Props {}

export const GarantLogo: FC<Props> = React.memo(() => {
  return (
    <span
      className="text-primary text-uppercase fw-bold fst-italic fs-2"
      style={{ fontFamily: "roboto" }}
    >
      Escrow
    </span>
  );
});
